import type { EmailDraft } from '@/gen/cortado/v1/emails_pb'

export type StagedAttachment = {
  id: string
  filename: string
  sizeBytes: bigint
  uploading?: boolean
}

export type EmailComposeFormValues = {
  fromAccountId: string
  subject: string
  body: string
}

export interface DraftSnapshot {
  subject: string
  body: string
  toEmails: string[]
  ccEmails: string[]
  bccEmails: string[]
  fromAccountId: string
  attachmentIds: string[]
}

export const emptyDraftSnapshot: DraftSnapshot = {
  subject: '',
  body: '',
  toEmails: [],
  ccEmails: [],
  bccEmails: [],
  fromAccountId: '',
  attachmentIds: [],
}

export function isHtmlEmpty(html: string) {
  return (
    html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim().length === 0
  )
}

export function appendEmailSignature(body: string, signatureHtml: string) {
  if (!signatureHtml) return body
  if (isHtmlEmpty(body)) return signatureHtml

  return `${body}<p></p>${signatureHtml}`
}

/** Draft attachments carry over as regular staged attachments on hydration. */
export function mapDraftAttachments(draft: EmailDraft): StagedAttachment[] {
  return draft.attachments.map((attachment) => ({
    id: attachment.id,
    filename: attachment.filename,
    sizeBytes: attachment.sizeBytes,
  }))
}

function arraysEqual(a: string[], b: string[]) {
  return a.length === b.length && a.every((value, index) => value === b[index])
}

export function draftSnapshotsEqual(a: DraftSnapshot, b: DraftSnapshot) {
  return (
    a.subject === b.subject &&
    a.body === b.body &&
    a.fromAccountId === b.fromAccountId &&
    arraysEqual(a.toEmails, b.toEmails) &&
    arraysEqual(a.ccEmails, b.ccEmails) &&
    arraysEqual(a.bccEmails, b.bccEmails) &&
    arraysEqual(a.attachmentIds, b.attachmentIds)
  )
}
